import {
  Box,
  Popover,
  SpaceBetween,
  StatusIndicator,
  StatusIndicatorProps,
} from '@amzn/awsui-components-core';
import constants from '../../common/constants';
import React from 'react';
import '../../resources/styles/scss/components/common/working-copy-status.scss';

export enum WorkingCopyStatusType {
  Saved = 'Saved',
  Saving = 'Saving',
  Error = 'Error',
  Pending = 'Pending',
}

interface Props {
  workingCopyStatus: WorkingCopyStatusType;
}

const WorkingCopyStatus: React.FC<Props> = ({ workingCopyStatus }) => {
  let statusType: StatusIndicatorProps.Type;
  let statusText: string;
  let tooltipText: string;

  switch (workingCopyStatus) {
    case WorkingCopyStatusType.Pending:
      statusType = 'pending';
      statusText = constants.WORKFLOW_WORKING_COPY_PENDING_TEXT;
      tooltipText = constants.WORKFLOW_WORKING_COPY_PENDING_TOOLTIP;
      break;
    case WorkingCopyStatusType.Saving:
      statusType = 'loading';
      statusText = constants.WORKFLOW_WORKING_COPY_LOADING_TEXT;
      tooltipText = constants.WORKFLOW_WORKING_COPY_LOADING_TOOLTIP;
      break;
    case WorkingCopyStatusType.Saved:
      statusType = 'success';
      statusText = constants.WORKFLOW_WORKING_COPY_SUCCESS_TEXT;
      tooltipText = constants.WORKFLOW_WORKING_COPY_SUCCESS_TOOLTIP;
      break;
    case WorkingCopyStatusType.Error:
      statusType = 'error';
      statusText = constants.WORKFLOW_WORKING_COPY_ERROR_TEXT;
      tooltipText = constants.WORKFLOW_WORKING_COPY_ERROR_TOOLTIP;
      break;
    default:
      return null;
  }

  return (
    <Box padding={{ left: 's' }} variant="div">
      <Popover content={tooltipText} triggerType="text" dismissAriaLabel="Close">
        <SpaceBetween direction="horizontal" size="xs">
          <StatusIndicator type={statusType}>
            <span className="word-styles">{statusText}</span>
          </StatusIndicator>
        </SpaceBetween>
      </Popover>
    </Box>
  );
};

export default WorkingCopyStatus;
